$(function ($) {
  var minutes = 15;
  var seconds = 0;

  var timer; // Will hold the timer 

  var shopify_clear = 0;
  function countDown() {
    //clear_checkout();
    clearInterval(timer); // Just incase 

    timer = setInterval(function(){

      // This function will occur every second 
      if (seconds > 0) { 
        seconds--;
      } 
      else if (minutes > 0) { 
        seconds = 59; 
        minutes--;
      } 
      else {
        if(shopify_clear == 0) {
          if($("#cart-timer").length) {
            $('#cart-timer').html("0m:0s");
            $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              data: '',
              dataType: 'json',
              success: function() { 
                //return Shopify.clear();

              },
              error: function(XMLHttpRequest, textStatus) {

              }
            });
          }
          clearInterval(timer);
        }
        $('#clockdiv').html("0m:0s");
        shopify_clear += 1;
      }  

      // Show the time left
      $('#clockdiv').html(minutes + "m:" + seconds + "s");
      if($("#cart-timer").length) {
        $('#cart-timer').html(minutes + "m:" + seconds + "s");
      }
    }, 1000);
  }
  function resetTimer() {
    timer;
    clearInterval(timer);

    // Reset time 
    minutes = 15;
    seconds = 0;

    // Show the time left
    $('#clockdiv').html(minutes + "m:" + seconds + "s");
    if($("#cart-timer").length) {
      $('#cart-timer').html(minutes + "m:" + seconds + "s");
    }
  }
  var get_us_shipping = '50';
  var get_int_shipping = '70';
  /*---------------- Responsive Menu ------------------*/
  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-wrap").toggleClass("off-canvas");
    e.preventDefault();
  });
  $('.menu-wrap').on("click", ".has-submenu a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    e.stopPropagation();
    e.preventDefault();
  });
  /*---------------- Responsive Menu ------------------*/

  /*---------------- Toggle Search ------------------*/
  $(".search-toggle").on('click', function (e) {
    $(".header-wrap").toggleClass('search-active');
    e.preventDefault();
  });
  /*---------------- Toggle Search ------------------*/
  $('.magnific-youtube').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  $('.title').on("click", function(e) {
    if ($(this).hasClass('menushow')) {
      remove_styles();
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    } else {
      remove_styles();
      $(this).addClass('menushow');
      $(this).next('ul').addClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').addClass('menushowtoggle');
      }
    }
    e.stopPropagation();
    e.preventDefault();
  });

  function remove_styles() {
    $('.title').each(function() {
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    });
  }

  /*---------------- FAQ PAGE ACCORDIAN STARTS ------------------*/
  $('body').on("click", '.home-faq-section-title-wrapper', function(e) {
    $(this).parent().siblings().find(".home-faq-section-title-wrapper").each(function () {
      $(this).next('.home-faq-section-content-container').slideUp(600);
      $(this).parent().removeClass("open");
      $(this).find('span').removeClass('ion-minus');
      $(this).find('span').addClass('ion-plus');
    });
    $(this).next('.home-faq-section-content-container').slideToggle(600);
    $(this).parent().toggleClass("open");
    $(this).find('span').toggleClass('ion-plus ion-minus');
    e.stopPropagation();
    e.preventDefault();
  });
  /*---------------- FAQ PAGE ACCORDIAN ENDS ------------------*/

  /*start: plus-minus quantity box*/
  $('body').on('click', '.qty-btn.plus', function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).closest('.qty-btns-main-wrap').find('input');

    // Get its current value
    var currentVal = parseInt(fieldName.val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      fieldName.val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      fieldName.val(1);
    }
  });
  // This button will decrement the value till 0
  $('body').on('click', '.qty-btn.minus', function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).closest('.qty-btns-main-wrap').find('input');
    // Get its current value
    var currentVal = parseInt(fieldName.val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      fieldName.val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      fieldName.val(1);
    }
  });
  /*end: plus-minus quantity box*/

  $('body').on('click', '.var-prd-wrap', function(e) {
    e.preventDefault();
    var varval = $(this).data('varval');
    //console.log(varval);
    $(this).closest('ul').find('li').each(function() {
      $(this).removeClass('selected-var');
    });
    $(this).addClass('selected-var');
    $('#addToCartForm').find('#change-variant-prd').val(varval);
  });

  /*---------------- Easy Responsive Tab ------------------*/
  if ($('#parentHorizontalTab').length) {
    $('#parentHorizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
  /*---------------- Easy Responsive Tab ------------------*/

  $(".related-slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(document).ready(function(e) {
    var moneyFormat = theme.moneyFormat;

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    $('body').on('click', '.dis-prd-popup-wrap', function(e) {
      e.preventDefault();
      var add_btn = $(this);
      var get_prd_var = $('.template-product #addToCartForm').find('#change-variant-prd').val();
      var get_prd_qty = $(this).closest('.prd-tp-cls-btn-wrap').find('.qty-btns-main-wrap input').val();

      var toadd=[];

      toadd.push({
        id: parseInt(get_prd_var),
        quantity: parseInt(get_prd_qty)
      });

      var checkLength = toadd.length;
      var itemCnt = 0;
      //console.log(toadd);
      //return false;
      function moveAlong() {
        if (toadd.length) {
          var request = toadd.shift();
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: request,
            dataType: 'json',
            async: false, 
            cache: false, 
            success: function(cart) {
              itemCnt = itemCnt + 1;
              moveAlong();

              if(checkLength == itemCnt) {
                //window.location.href='/cart';
                $("#prd-atc-popup").modal('show');
                $('.prd-atc-img-wrap').html('');
                $('.prd-atc-title-wrap').html('');
                $('.prd-atc-qty-wrap').html('');
                $('.prd-atc-total-wrap').html('');
                $('.prd-atc-cart-ttl-itms-wrap').html('');
                $('.prd-atc-cart-ttl-wrap').html('');
                $('.prd-atc-ship-msg-wrap').html('');
                $('.cart-msg-wrap').html('');

                $('.cart-msg-wrap').html('Added to cart successfully');
                var get_img_src = $('.variant-data-wrap').find('#'+get_prd_var+' .get_img_src').attr('data-sinvarimg');
                $('.prd-atc-img-wrap').html('<img src="'+get_img_src+'" />');
                var get_title_src = $('.variant-data-wrap').find('#'+get_prd_var).attr('data-sinvartitle');
                $('.prd-atc-title-wrap').html(get_title_src);
                var get_qty_src = parseInt(get_prd_qty);
                $('.prd-atc-qty-wrap').html('Quantity: '+get_qty_src);
                var get_prc_src = $('.variant-data-wrap').find('#'+get_prd_var).attr('data-sinvarprc');
                $('.prd-atc-total-wrap').html('<span>Total price: </span><span class="var-prc-src">'+get_prc_src+'</span>');

                /*var data = null;
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;
                xhr.addEventListener("readystatechange", function () {
                  if (this.readyState === 4) {
                    var res = JSON.parse(this.responseText);
                    if (typeof res.location !== 'undefined'){
                      getprdCountry(res.location.lat,res.location.lng);
                    }
                  }
                });
                xhr.open("POST", "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyCNMubcbKM6x0tC3sWJsAEcCM6bLXtDvQ8&considerIp=true");
                xhr.setRequestHeader("content-type", "application/json");
                xhr.setRequestHeader("cache-control", "no-cache");
                xhr.setRequestHeader("postman-token", "e485e4fb-f961-e80c-51e4-172f7842876c");
                xhr.send(data);*/
                function get_cur_location(){
                  var currentLatitude = '';
                  var currentLongitude = '';

                  if ("geolocation" in navigator){
                    navigator.geolocation.getCurrentPosition(function(position){
                      currentLatitude = position.coords.latitude;
                      currentLongitude = position.coords.longitude;
                      getprdCountry(currentLatitude,currentLongitude);
                    });
                  }
                }
                get_cur_location();
                //clear_checkout();
                resetTimer();
                countDown();
              }
            },
            error: cartFail
          };
          $.ajax(params);
        }
      }

      function getprdCountry(lat,lng) {
        var data = null;
        var xhr = new XMLHttpRequest();
        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            var res = JSON.parse(this.responseText);
            //console.log(res);
            if (typeof res.short_name !== 'undefined'){
              var cartdata = [];
              $.ajax({ 
                type: 'GET',
                url: '/cart.js',
                async: false, 
                cache: false, 
                dataType: 'json',
                success: function (json) {
                  cartdata = json;
                }
              });

              var final_get_prd_us_shipping = get_us_shipping*100;
              var final_get_prd_int_shipping = get_int_shipping*100;
              var final_omni_prd_shipping = '';

              var get_cart_count = '';

              if(cartdata.item_count == 1) {
                get_cart_count = 'is 1 item';
              }
              else {
                get_cart_count = 'are '+cartdata.item_count+' items';
              }

              $('.cart-main-wrap .items-cnt span').html(cartdata.item_count);
              $('.mob-cart-wrap .mob-items-cnt span').html(cartdata.item_count);
              $('.prd-atc-cart-ttl-itms-wrap').html('There '+get_cart_count+' in your cart.');
              $('.prd-atc-cart-ttl-wrap').html('<span>Subtotal: </span><span class="cart-atc-prc-wrap"> '+formatMoney(cartdata.items_subtotal_price, moneyFormat)+'</span>');

              if (res.short_name === 'US') {
                final_omni_prd_shipping = final_get_prd_us_shipping;
              }
              else {
                final_omni_prd_shipping = final_get_prd_int_shipping;
              }

              $('#prd-atc-popup .final-cart-ship-prg').html(formatMoney(final_omni_prd_shipping,moneyFormat));
              if(cartdata.items_subtotal_price < final_omni_prd_shipping) {
                $('.prd-atc-ship-msg-wrap').html('You are '+formatMoney((final_omni_prd_shipping - cartdata.items_subtotal_price), moneyFormat)+' away from FREE shipping');
                $('.prd-atc-ship-msg-wrap').removeClass('success-wrap-crt');
                var get_prg_perc = 100 - (((final_omni_prd_shipping - cartdata.items_subtotal_price) / final_omni_prd_shipping) * 100);
                $('.progress-bar').attr('aria-valuenow',get_prg_perc);
                $('.progress-bar').css({'width':get_prg_perc+'%'});
                $('.progress-bar').find('.sr-only').html(get_prg_perc+'% Complete');
              }
              else {
                $('.prd-atc-ship-msg-wrap').html('You are eligible for FREE shipping');
                $('.prd-atc-ship-msg-wrap').addClass('success-wrap-crt');
                $('.progress-bar').attr('aria-valuenow',100);
                $('.progress-bar').css({'width':100+'%'});
                $('.progress-bar').find('.sr-only').html(100+'% Complete');
              }
              $('.elephant-msg-wrap .playing-cards-msg-text-wrap').show();
              if(cartdata.item_count > 0) {
                //console.log(cartdata1.items_subtotal_price);
                if(cartdata.items_subtotal_price < final_omni_prd_shipping) {
                  var get_diff_head_msg = final_omni_prd_shipping - cartdata.items_subtotal_price;
                  get_diff_head_msg = formatMoney(get_diff_head_msg,moneyFormat);
                  $('.playing-cards-msg-text-wrap').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
                  $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
                }
                else {
                  $('.playing-cards-msg-text-wrap').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
                  $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
                }
              }
              else {
                $('.playing-cards-msg-text-wrap').html("The world's most interesting <span>playing cards</span>");
                if (res.short_name === 'US') {
                  $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free Domestic Shipping <span class="white-clr">For Order <b>Over '+formatMoney(final_omni_prd_shipping,moneyFormat)+'</b></span>');
                }
                else {
                  $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free International Shipping <span class="white-clr">For Order <b>Over '+formatMoney(final_omni_prd_shipping,moneyFormat)+'</b></span>');
                }
              }
            }
          }
        });
        xhr.open("GET", `https://app.shopifyexpertz.com/elephant-playing-cards/get-country.php?lat=${lat}&lng=${lng}`);
        xhr.send(data);
      }

      function cartFail(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        //$(".modal").modal('hide');
        //$("#out_of_stock").modal('show');
        //$("#out_of_stock .modal-body .out-of-stock-ajax-msg-wrap").html('');
        //$("#out_of_stock .modal-body .out-of-stock-ajax-msg-wrap").html(response.description);
        console.clear();
      }
      moveAlong();

    });

    var get_total = 0;
    if ($(".total-ext-prc-container .total-ext-prc").length) {
      $(".total-ext-prc-container .total-ext-prc").each(function () {
        var get_row_total_prc = $(this).html();
        get_row_total_prc = get_row_total_prc.replace(/\D/g,'');
        get_row_total_prc = parseInt(get_row_total_prc);
        get_total = get_total + get_row_total_prc;
      });
    }
    if (get_total > 0) {
      get_total = formatMoney(get_total, moneyFormat);
      $(".cart-ele-total").html(get_total);
    }
  });

  $(document).ready(function(){
    var moneyFormat1 = theme.moneyFormat;

    function formatMoney1(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat1;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
    var cartdata1 = [];
    $.ajax({ 
      type: 'GET',
      url: '/cart.js',
      async: false, 
      cache: false, 
      dataType: 'json',
      success: function (json) {
        cartdata1 = json;
      }
    });

    var final_get_us_shipping = get_us_shipping*100;
    var final_get_int_shipping = get_int_shipping*100;

    var final_omni_shipping = '';

    function getCountry(lat,lng){
      var data = null;
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          var res = JSON.parse(this.responseText);
          //console.log(res);
          if (typeof res.short_name !== 'undefined'){
            $('.mob-int-shipping-msg-wrap').hide();
            $('.mob-shipping-msg-wrap').hide();
            if (res.short_name === 'US') {
              if($('.shipping-cart-msg').length) {
                $('.shipping-cart-msg').html('Free Delivery on orders over $50');
              }
              if($(window).width() > 768) {
                $('.primary-navbar > li.heading-shipping-wrap.desktop-shipping-wrp').css({'display':'inline-block'});
              }
              else {
                $('.mob-shipping-msg-wrap').show();
              }
              $('.primary-navbar > li.heading-shipping-wrap.int-heading-shipping-wrap').hide();
              
              final_omni_shipping = final_get_us_shipping;
            }else{
              if($('.shipping-cart-msg').length) {
                $('.shipping-cart-msg').html('Free Delivery on orders over $70');
              }
              if($(window).width() > 768) {
                $('.primary-navbar > li.heading-shipping-wrap.int-heading-shipping-wrap').css({'display':'inline-block'});
              }
              else {
                $('.mob-int-shipping-msg-wrap').show();
              }
              $('.primary-navbar > li.heading-shipping-wrap.desktop-shipping-wrp').hide();
              
              final_omni_shipping = final_get_int_shipping;
            }

            $('.free-del-prd-prc-wrap').html(formatMoney1(final_omni_shipping,moneyFormat1));
            if(cartdata1.items_subtotal_price < final_omni_shipping) {
              $('.template-cart .progress-bar-wrp h2').html('You are '+formatMoney1((final_omni_shipping - cartdata1.items_subtotal_price), moneyFormat1)+' away from FREE shipping');
              $('.template-cart .progress-bar-wrp h2').removeClass('success-wrap-crt');
              var get_prg_perc = 100 - (((final_omni_shipping - cartdata1.items_subtotal_price) / final_omni_shipping) * 100);
              $('.template-cart .progress-bar').attr('aria-valuenow',get_prg_perc);
              $('.template-cart .progress-bar').css({'width':get_prg_perc+'%'});
              $('.template-cart .progress-bar').find('.sr-only').html(get_prg_perc+'% Complete');
              $('.template-cart .final-cart-ship-prg').html(formatMoney1(final_omni_shipping,moneyFormat1));
            }
            else {
              $('.template-cart .progress-bar-wrp h2').html('You are eligible for FREE shipping');
              $('.template-cart .progress-bar-wrp h2').addClass('success-wrap-crt');
              $('.template-cart .progress-bar').attr('aria-valuenow',100);
              $('.template-cart .progress-bar').css({'width':100+'%'});
              $('.template-cart .progress-bar').find('.sr-only').html(100+'% Complete');
              $('.template-cart .final-cart-ship-prg').html(formatMoney1(final_omni_shipping,moneyFormat1));
            }
            $('.elephant-msg-wrap .playing-cards-msg-text-wrap').show();
            if(cartdata1.item_count > 0) {
              //console.log(cartdata1.items_subtotal_price);
              if(cartdata1.items_subtotal_price < final_omni_shipping) {
                var get_diff_head_msg = final_omni_shipping - cartdata1.items_subtotal_price;
                get_diff_head_msg = formatMoney1(get_diff_head_msg,moneyFormat1);
                $('.playing-cards-msg-text-wrap').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
                $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
              }
              else {
                $('.playing-cards-msg-text-wrap').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
                $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
              }
            }
            else {
              $('.playing-cards-msg-text-wrap').html("The world's most interesting <span>playing cards</span>");
              if (res.short_name === 'US') {
                $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free Domestic Shipping <span class="white-clr">For Order <b>Over '+formatMoney1(final_omni_shipping,moneyFormat1)+'</b></span>');
              }
              else {
                $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free International Shipping <span class="white-clr">For Order <b>Over '+formatMoney1(final_omni_shipping,moneyFormat1)+'</b></span>');
              }
            }
          }
        }
      });
      xhr.open("GET", `https://app.shopifyexpertz.com/elephant-playing-cards/get-country.php?lat=${lat}&lng=${lng}`);
      xhr.send(data);
    }
    /*var data = null;
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        //console.log(this);
        var res = JSON.parse(this.responseText);
        if (typeof res.location !== 'undefined'){
          getCountry(res.location.lat,res.location.lng);
        }
      }
    });
    xhr.open("POST", "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyCNMubcbKM6x0tC3sWJsAEcCM6bLXtDvQ8&considerIp=true");
    xhr.setRequestHeader("content-type", "application/json");
    xhr.setRequestHeader("cache-control", "no-cache");
    xhr.setRequestHeader("postman-token", "e485e4fb-f961-e80c-51e4-172f7842876c");
    xhr.send(data);*/
    function get_current_location(){
      var currentLatitude = '';
      var currentLongitude = '';

      if ("geolocation" in navigator){
        navigator.geolocation.getCurrentPosition(function(position){
          currentLatitude = position.coords.latitude;
          currentLongitude = position.coords.longitude;
          getCountry(currentLatitude,currentLongitude);
        });
      }
    }
    get_current_location();
  });

  /**/
  var container = [];
  var desccontainer = [];
  var mobgalccontainer = [];
  /*$('#gallery').find('.prd-gal-swp').each(function(){
    var $link = $(this).find('a'),
        item = {
          src: $link.attr('href'),
          w: $link.data('width'),
          h: $link.data('height'),
          title: $link.data('caption')
        };
    container.push(item);
  });

  // Define click event on gallery item
  $('body').on('click', '#gallery a', function(event){

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
        options = {
          index: $(this).parent('.prd-gal-swp').index(),
          bgOpacity: 0.85,
          showHideOpacity: true
        };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();
  });*/

  $('.prd-sin-cont-main-wrap').find('.prd-cnt-gal-swp').each(function(){
    var $link = $(this).find('a'),
        item = {
          src: $link.attr('href'),
          w: $link.data('width'),
          h: $link.data('height'),
          title: 'Image Description'
        };
    desccontainer.push(item);
  });

  // Define click event on gallery item
  $('body').on('click', '.prd-sin-cont-main-wrap a', function(event){
    // Prevent location change
    event.preventDefault();
    //var test = $(this).parent('.prd-gal-swp');
    // Define object and gallery options
    var $pswp = $('.pswp')[0],
        options = {
          index: $(this).parent('.prd-cnt-gal-swp').data('countertmb')-1,
          bgOpacity: 0.85,
          showHideOpacity: true
        };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, desccontainer, options);
    gallery.init();
  });


  $('#mobgallery').find('.prd-mob-gal-swp').each(function(){
    var $link = $(this).find('a'),
        item = {
          src: $link.attr('href'),
          w: $link.data('width'),
          h: $link.data('height'),
          title: 'Image Description'
        };
    mobgalccontainer.push(item);
  });

  // Define click event on gallery item
  $('body').on('click', '#mobgallery a', function(event){
    // Prevent location change
    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
        options = {
          index: $(this).parent('.prd-mob-gal-swp').index(),
          bgOpacity: 0.85,
          showHideOpacity: true
        };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, mobgalccontainer, options);
    gallery.init();
  });

  $('.prd-mob-sin-cont-main-wrap').find('.prd-mob-cnt-gal-swp').each(function(){
    var $link = $(this).find('a'),
        item = {
          src: $link.attr('href'),
          w: $link.data('width'),
          h: $link.data('height'),
          title: 'Image Description'
        };
    container.push(item);
  });

  // Define click event on gallery item
  $('body').on('click', '.prd-mob-sin-cont-main-wrap a', function(event){
    // Prevent location change
    event.preventDefault();
    // Define object and gallery options
    var $pswp = $('.pswp')[0],
        options = {
          index: $(this).parent('.prd-mob-cnt-gal-swp').data('countertmb')-1,
          bgOpacity: 0.85,
          showHideOpacity: true
        };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();
  });
  /**/

  /*---------------- EQUAL HEIGHT START ------------------*/
  $(window).on('load',function() {
    equalheight('.template-product .prd-mob-gal-swp');
    equalheight('.home-logo-section .home-custom-steps');
    equalheight('.rel-prod-img-view-section');
    equalheight('.related-prd-grid-wrap .prod-title-link');
    equalheight('.related-prd-grid-wrap .rel-product-content');
    equalheight('.col-title-wrap a');
  });

  $(window).on('resize',function() {
    equalheight('.template-product .prd-mob-gal-swp');
    equalheight('.home-logo-section .home-custom-steps');
    equalheight('.rel-prod-img-view-section');
    equalheight('.related-prd-grid-wrap .prod-title-link');
    equalheight('.related-prd-grid-wrap .rel-product-content');
    equalheight('.col-title-wrap a');
  });
  /*---------------- EQUAL HEIGHT END ------------------*/

  /**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * Modified by David Little, 2016
 */
  if($('#shipping-calculator') !== undefined && $('#shipping-calculator').length) {
    "object"==typeof Countries&&(Countries.updateProvinceLabel=function(e,t){if("string"==typeof e&&Countries[e]&&Countries[e].provinces){if("object"!=typeof t&&(t=document.getElementById("address_province_label"),null===t))return;t.innerHTML=Countries[e].label;var r=jQuery(t).parent();r.find("select");r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])}}),"undefined"==typeof Shopify.Cart&&(Shopify.Cart={}),Shopify.Cart.ShippingCalculator=function(){var _config={submitButton:"Calculate shipping",submitButtonDisabled:"Calculating...",templateId:"shipping-calculator-response-template",wrapperId:"wrapper-response",customerIsLoggedIn:!1,moneyFormat:"$"},_render=function(e){var t=jQuery("#"+_config.templateId),r=jQuery("#"+_config.wrapperId);if(t.length&&r.length){var templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var n=Handlebars.compile(jQuery.trim(t.text())),a=n(e);if(jQuery(a).appendTo(r),"undefined"!=typeof Currency&&"function"==typeof Currency.convertAll){var i="";jQuery("[name=currencies]").size()?i=jQuery("[name=currencies]").val():jQuery("#currencies span.selected").size()&&(i=jQuery("#currencies span.selected").attr("data-currency")),""!==i&&Currency.convertAll(shopCurrency,i,"#wrapper-response span.money, #estimated-shipping span.money")}}},_enableButtons=function(){jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)},_disableButtons=function(){jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled","disabled").addClass("disabled")},_getCartShippingRatesForDestination=function(e){var t={type:"POST",url:"/cart/prepare_shipping_rates",data:jQuery.param({shipping_address:e}),success:_pollForCartShippingRatesForDestination(e),error:_onError};jQuery.ajax(t)},_pollForCartShippingRatesForDestination=function(e){var t=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(r,n,a){200===a.status?_onCartShippingRatesUpdate(r.shipping_rates,e):setTimeout(t,500)},error:_onError})};return t},_fullMessagesFromErrors=function(e){var t=[];return jQuery.each(e,function(e,r){jQuery.each(r,function(r,n){t.push(e+" "+n)})}),t},_onError=function(XMLHttpRequest,textStatus){jQuery("#estimated-shipping").hide(),jQuery("#estimated-shipping em").empty(),_enableButtons();var feedback="",data=eval("("+XMLHttpRequest.responseText+")");feedback=data.message?data.message+"("+data.status+"): "+data.description:"Error : "+_fullMessagesFromErrors(data).join("; ")+".","Error : country is not supported."===feedback&&(feedback="We do not ship to this destination."),_render({rates:[],errorFeedback:feedback,success:!1}),jQuery("#"+_config.wrapperId).show()},_onCartShippingRatesUpdate=function(e,t){_enableButtons();var r="";if(t.zip&&(r+=t.zip+", "),t.province&&(r+=t.province+", "),r+=t.country,e.length){"0.00"==e[0].price?jQuery("#estimated-shipping em").html("FREE"):jQuery("#estimated-shipping em").html(_formatRate(e[0].price));for(var n=0;n<e.length;n++)e[n].price=_formatRate(e[n].price)}_render({rates:e,address:r,success:!0}),jQuery("#"+_config.wrapperId+", #estimated-shipping").fadeIn()},_formatRate=function(e){function t(e,t){return"undefined"==typeof e?t:e}function r(e,r,n,a){if(r=t(r,2),n=t(n,","),a=t(a,"."),isNaN(e)||null==e)return 0;e=(e/100).toFixed(r);var i=e.split("."),o=i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+n),s=i[1]?a+i[1]:"";return o+s}if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(e,_config.moneyFormat);"string"==typeof e&&(e=e.replace(".",""));var n="",a=/\{\{\s*(\w+)\s*\}\}/,i=_config.moneyFormat;switch(i.match(a)[1]){case"amount":n=r(e,2);break;case"amount_no_decimals":n=r(e,0);break;case"amount_with_comma_separator":n=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":n=r(e,0,".",",")}return i.replace(a,n)};return _init=function(){new Shopify.CountryProvinceSelector("address_country","address_province",{hideElement:"address_province_container"});var e=jQuery("#address_country"),t=jQuery("#address_province_label").get(0);"undefined"!=typeof Countries&&(Countries.updateProvinceLabel(e.val(),t),e.change(function(){Countries.updateProvinceLabel(e.val(),t)})),jQuery(".get-rates").click(function(){_disableButtons(),jQuery("#"+_config.wrapperId).empty().hide();var e={};e.zip=jQuery("#address_zip").val()||"",e.country=jQuery("#address_country").val()||"",e.province=jQuery("#address_province").val()||"",_getCartShippingRatesForDestination(e)}),_config.customerIsLoggedIn&&jQuery(".get-rates:eq(0)").trigger("click")},{show:function(e){e=e||{},jQuery.extend(_config,e),jQuery(function(){_init()})},getConfig:function(){return _config},formatRate:function(e){return _formatRate(e)}}}();
}
    /***/
    if($('#shipping-calculator') !== undefined && $('#shipping-calculator').length) {
      if(Shopify) {
        Shopify.Cart.ShippingCalculator.show( {
          submitButton: theme.strings.shippingCalcSubmitButton,
          submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
          customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
          moneyFormat: theme.strings.shippingCalcMoneyFormat
        } );
      }
    }

  /****************
   *
   *
   *
   *
  */

  /*---------------- APPLY DISCOUNT CODE ------------------*/
  $('body').on('click', '.disc-code-btn-wrap', function(e) {
    e.preventDefault();
    //document.cookie = "discount_code= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
    var checkdisccode = $(this).parents('.discount-code').find('#discount-code').val();
    var get_cur_btn = $(this);
    get_cur_btn.parents('.discount-code').find('.disc-values').html('');
    get_cur_btn.parents('.discount-code').find('.get-fnl-prc-wrap').html('');
    get_cur_btn.parents('.discount-code').find('.rmv-disc-vals').html('');
    $.ajax({
      type: 'GET',
      //url: '/discount/CODE050',
      url: '/discount/'+checkdisccode,
      success: function(data) {
        //console.log(data);
      },
      error: function(XMLHttpRequest, textStatus) {
        //console.log(XMLHttpRequest, textStatus);
      }
    });
    $.ajax({
      type: 'GET',
      url: '/checkout/?discount='+checkdisccode,
      dataType : 'html',
      success: function(data) {
        if(data.indexOf('checkout_clear_discount') !== -1) {
          var get_discs1 = $(data).find('.total-line--reduction th').html();
          var get_discs2 = $(data).find('.total-line--reduction td').html();
          var get_final_prc = $(data).find('.payment-due__price').html();
          $('.success-disc-apply-wrap').html('Discount applied successfully.');
          get_cur_btn.parents('.discount-code').find('.disc-values').html(get_discs1+get_discs2);
          get_cur_btn.parents('.discount-code').find('.get-fnl-prc-wrap').html('<span class="disc-tot-txt-wrap">Total</span><span class="fin-prc-txt-wrap">'+get_final_prc+'</span>');
          $('.reduction-code').html('<svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg><span class="reduction-code__text">'+checkdisccode+'</span>');
          //get_cur_btn.parents('.discount-code').find('.rmv-disc-vals').html(get_rmv_disc);
        }
        else {
          //console.log('error');
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    });

  });

  $(document).ready(function() {
    if($('.template-cart') !== undefined && $('.template-cart').length) {
      var checkdisccode = $('.disc-code-btn-wrap').parents('.discount-code').find('#discount-code').val();
      var get_cur_btn = $('.disc-code-btn-wrap');
      get_cur_btn.parents('.discount-code').find('.disc-values').html('');
      get_cur_btn.parents('.discount-code').find('.get-fnl-prc-wrap').html('');
      get_cur_btn.parents('.discount-code').find('.rmv-disc-vals').html('');
      $.ajax({
        type: 'GET',
        url: '/checkout',
        dataType : 'html',
        success: function(data) {
          if(data.indexOf('checkout_clear_discount') !== -1) {
            var get_discs1 = $(data).find('.total-line--reduction th').html();
            var get_discs2 = $(data).find('.total-line--reduction td').html();
            var get_final_prc = $(data).find('.payment-due__price').html();
            $('.success-disc-apply-wrap').html('Discount applied successfully.');
            var get_final_desccode = $(data).find('.reduction-code__text').html();
            get_cur_btn.parents('.discount-code').find('.disc-values').html(get_discs1+get_discs2);
            get_cur_btn.parents('.discount-code').find('.get-fnl-prc-wrap').html('<span class="disc-tot-txt-wrap">Total</span><span class="fin-prc-txt-wrap">'+get_final_prc+'</span>');
            $('.reduction-code').html('<svg id="tags-filled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg></svg><span class="reduction-code__text">'+get_final_desccode+'</span>');
          }
          else {
            //console.log('error');
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest, textStatus);
        }
      });
    }
  });
  /*---------------- APPLY DISCOUNT CODE ------------------*/

  $(document).ready(function() {
    var check_cart = [];
    $.ajax({ 
      type: 'GET',
      url: '/cart.js',
      async: false, 
      cache: false, 
      dataType: 'json',
      success: function (json) {
        check_cart = json;
      }
    });
    if(check_cart.item_count > 0) {
      countDown();
    }
  });
  /**/

  $('body').on('click', '.slide-dropdown', function(e) {
    $(this).parents('.open-close-drop').find('.hide-show-wrap').slideToggle(600);
  });
  $('body').on('click', '.discount-title', function(e) {
    $(this).parents('.open-close-drop').find('.hide-show-wrap').slideToggle(600);
  });
  /**/
  $('body').on('click', '.bundle-cart-btn', function(e) {
    e.preventDefault();
    var add_btn = $(this);
    var parent_fieldset = $(this).closest('.buy-products-bundle-wrap');

    var toadd=[];
    var toTemp=[];

    if(parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').length > 0) {
      var get_cart_disc = parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').length;
      var get_properties = '';
      if(get_cart_disc == 2) {
        get_properties = jQuery.parseJSON( '{ "Discountcustom": "'+10+'%" }' );
      }
      if(get_cart_disc == 3) {
        get_properties = jQuery.parseJSON( '{ "Discountcustom": "'+15+'%" }' );
      }

      parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').each(function() {
        toadd.push({
          id: parseInt($(this).val()),
          quantity: 1,
          properties: get_properties

        });
        toTemp.push({
          id: parseInt($(this).val()),
          quantity: 1,
          properties: get_properties
        });
      });
    }

    var checkLength = toadd.length;
    var itemCnt = 0;

    //console.log(toadd);
    //return false;
    if (toTemp.length > 0) {
      function moveAlong() {
        if (toadd.length) {
          var request = toadd.shift();
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: request,
            dataType: 'json',
            async: false, 
            cache: false, 
            success: function(cart) {
              itemCnt = itemCnt + 1;
              moveAlong();

              if(checkLength == itemCnt) {
                window.location.href='/cart';
              }
            },
            error: cartFail
          };
          $.ajax(params);
        }
      }

      function cartFail(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        console.clear();
      }
      moveAlong();
    }
    else {
      console.log('No items selected for buy together discount section');
    }
  });
  /**/

  $('body').on('change', '.buy-bundle-prd-checkbox-wrap .checkbox', function(e) {
    var moneyFormat2 = theme.moneyFormat;

    function formatMoney2(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat2;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
    var parent_fieldset = $(this).closest('.buy-products-bundle-wrap');
    if(parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').length > 0) {
      var get_cart_disc = parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').length;
      var get_prc_buy_total = 0;
      var get_var_bundle_prc = formatMoney2($('.get-bundle-strt-prc').data('bund-strt-prc'),moneyFormat2);
      parent_fieldset.find('.related-prd-grid-wrap .checkbox:checked').each(function() {
        get_prc_buy_total += $(this).data('prc');
      });

      var get_discounted_prc = formatMoney2(0,moneyFormat2);
      var get_bundle_prc = formatMoney2($('.get-bundle-strt-prc').data('bund-strt-prc'),moneyFormat2);
      var disc_percntage = 0;
      if(get_prc_buy_total > 0) {
        if(get_cart_disc == 2) {
          disc_percntage = 10;
          get_discounted_prc = formatMoney2(((get_prc_buy_total) - ((get_prc_buy_total) * ((100-disc_percntage) / 100))),moneyFormat2);
          get_bundle_prc = formatMoney2((((get_prc_buy_total) * ((100-disc_percntage) / 100))),moneyFormat2);
          get_var_bundle_prc = formatMoney2((get_prc_buy_total),moneyFormat2);
        }
        else if(get_cart_disc == 3) {
          disc_percntage = 15;
          get_discounted_prc = formatMoney2(((get_prc_buy_total) - ((get_prc_buy_total) * ((100-disc_percntage) / 100))),moneyFormat2);
          get_bundle_prc = formatMoney2((((get_prc_buy_total) * ((100-disc_percntage) / 100))),moneyFormat2);
          get_var_bundle_prc = formatMoney2((get_prc_buy_total),moneyFormat2);
        }
      }
      //console.log(get_var_bundle_prc);
      $('.get-bundle-strt-prc').text(get_var_bundle_prc);
      $('.buy-bundle-fin-prc').text(get_bundle_prc);
      $('.buy-tog-save-prc').text(get_discounted_prc);
      $('.buy-tog-save-percentage').text('('+disc_percntage+'%)');
    }
  });

  $('body').on('click', '.read-more-prd-link', function(e) {
    e.preventDefault();
    $(this).closest('.mob-desc-toggle-desc').toggleClass('read-more-read-less');

    if($(this).closest('.mob-desc-toggle-desc').hasClass('read-more-read-less')) {
      $(this).closest('.mob-desc-toggle-desc').find('.collapsible-desc-wrap').slideDown(600);
      $(this).html('read less');
    }
    else {
      $(this).closest('.mob-desc-toggle-desc').find('.collapsible-desc-wrap').slideUp(600);
      $(this).html('read more');
    }
  });

  /*---------------- Easy Responsive Tab ------------------*/
  $(document).ready(function () {
    if ($('#mobparentHorizontalTab').length) {
      $('#mobparentHorizontalTab').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion
        closed: true,
        width: 'auto', //auto or any width like 600px
        fit: true, // 100% fit in a container
        tabidentify: 'hor_1', // The tab groups identifier
        activate: function(event) { // Callback function if tab is switched
          var $tab = $(this);
          var $info = $('#nested-tabInfo');
          var $name = $('span', $info);
          $name.text($tab.text());
          $info.show();
        }
      });
    }
  });
  /*---------------- Easy Responsive Tab ------------------*/

  $('body').on('blur', '.mob-qty-input', function (e) {
    $(this).closest('.cart__row').find('.chg-mob-desk-qty-wrap input').val($(this).val());
  });


  /*******************************************************/
  $(document).on("click", ".col-add-cart-wrap", function(event) {
    event.preventDefault();

    var get_cur = $(this);
    $(this).html('Added');
    $(this).attr('disabled',true);
    var form = $(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(cart) {

        function get_cur_col_location(){
          var currentLatitude = '';
          var currentLongitude = '';

          if ("geolocation" in navigator){
            navigator.geolocation.getCurrentPosition(function(position){
              currentLatitude = position.coords.latitude;
              currentLongitude = position.coords.longitude;
              getprdColCountry(currentLatitude,currentLongitude);
            });
          }
        }
        get_cur_col_location();
        resetTimer();
        countDown();
        setTimeout(function() {
          $(get_cur).html('add to cart');
          $(get_cur).attr('disabled',false);
        }, 1000);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        //alert("An error occurred: can't reach server");
        //console.log(XMLHttpRequest.responseText.description);
        //console.log(textStatus);
      },
    });
  });

  function getprdColCountry(lat,lng) {

    /***********************************/
    var moneyFormat2 = theme.moneyFormat;

    function formatMoney2(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat2;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
    /***********************************/

    var data = null;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        var res = JSON.parse(this.responseText);
        //console.log(res);
        if (typeof res.short_name !== 'undefined'){
          var cartdata = [];
          $.ajax({ 
            type: 'GET',
            url: '/cart.js',
            async: false, 
            cache: false, 
            dataType: 'json',
            success: function (json) {
              cartdata = json;
            }
          });

          var final_get_prd_us_shipping = get_us_shipping*100;
          var final_get_prd_int_shipping = get_int_shipping*100;
          var final_omni_prd_shipping = '';

          var get_cart_count = '';

          if(cartdata.item_count == 1) {
            get_cart_count = 'is 1 item';
          }
          else {
            get_cart_count = 'are '+cartdata.item_count+' items';
          }

          $('.cart-main-wrap .items-cnt span').html(cartdata.item_count);
          $('.mob-cart-wrap .mob-items-cnt span').html(cartdata.item_count);
          $('.prd-atc-cart-ttl-itms-wrap').html('There '+get_cart_count+' in your cart.');
          $('.prd-atc-cart-ttl-wrap').html('<span>Subtotal: </span><span class="cart-atc-prc-wrap"> '+formatMoney2(cartdata.items_subtotal_price, moneyFormat2)+'</span>');

          if (res.short_name === 'US') {
            final_omni_prd_shipping = final_get_prd_us_shipping;
          }
          else {
            final_omni_prd_shipping = final_get_prd_int_shipping;
          }

          $('#prd-atc-popup .final-cart-ship-prg').html(formatMoney2(final_omni_prd_shipping,moneyFormat2));
          if(cartdata.items_subtotal_price < final_omni_prd_shipping) {
            $('.prd-atc-ship-msg-wrap').html('You are '+formatMoney2((final_omni_prd_shipping - cartdata.items_subtotal_price), moneyFormat2)+' away from FREE shipping');
            $('.prd-atc-ship-msg-wrap').removeClass('success-wrap-crt');
            var get_prg_perc = 100 - (((final_omni_prd_shipping - cartdata.items_subtotal_price) / final_omni_prd_shipping) * 100);
            $('.progress-bar').attr('aria-valuenow',get_prg_perc);
            $('.progress-bar').css({'width':get_prg_perc+'%'});
            $('.progress-bar').find('.sr-only').html(get_prg_perc+'% Complete');
          }
          else {
            $('.prd-atc-ship-msg-wrap').html('You are eligible for FREE shipping');
            $('.prd-atc-ship-msg-wrap').addClass('success-wrap-crt');
            $('.progress-bar').attr('aria-valuenow',100);
            $('.progress-bar').css({'width':100+'%'});
            $('.progress-bar').find('.sr-only').html(100+'% Complete');
          }
          $('.elephant-msg-wrap .playing-cards-msg-text-wrap').show();
          if(cartdata.item_count > 0) {
            //console.log(cartdata1.items_subtotal_price);
            if(cartdata.items_subtotal_price < final_omni_prd_shipping) {
              var get_diff_head_msg = final_omni_prd_shipping - cartdata.items_subtotal_price;
              get_diff_head_msg = formatMoney2(get_diff_head_msg,moneyFormat2);
              $('.playing-cards-msg-text-wrap').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
              $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("You're only "+get_diff_head_msg+" away from <span>free shipping</span>");
            }
            else {
              $('.playing-cards-msg-text-wrap').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
              $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html("<span class='only-capitalize'>congratulations,</span> you have <span>free shipping!</span>");
            }
          }
          else {
            $('.playing-cards-msg-text-wrap').html("The world's most interesting <span>playing cards</span>");
            if (res.short_name === 'US') {
              $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free Domestic Shipping <span class="white-clr">For Order <b>Over '+formatMoney2(final_omni_prd_shipping,moneyFormat)+'</b></span>');
            }
            else {
              $('.mob-int-shipping-msg-wrap').find('.width-84-perc').html('Free International Shipping <span class="white-clr">For Order <b>Over '+formatMoney2(final_omni_prd_shipping,moneyFormat)+'</b></span>');
            }
          }
        }
      }
    });
    xhr.open("GET", `https://app.shopifyexpertz.com/elephant-playing-cards/get-country.php?lat=${lat}&lng=${lng}`);
    xhr.send(data);
  }

  /*******************************************************/
});